// Text for the assistant shell (tabs, alerts list, coming-soon chat).
// Merged in I18nContext as `assistant`.

export const assistantStrings = {
  ar: {
    title: "مساعد تمهيد",
    tabChat: "المحادثة",
    tabAlerts: "التنبيهات",
    alertsLabel: "التنبيهات",
    markAllRead: "تحديد الكل كمقروء",
    explain: "اشرح لي",
    explainPrompt: "اشرح لي هذا التنبيه: ",
    noAlerts: "لا توجد تنبيهات حاليًا",
    loadFailed: "تعذّر تحميل التنبيهات",
    retry: "إعادة المحاولة",
    loading: "جارٍ التحميل…",
    unread: "غير مقروء",
    severity: { critical: "عاجل", important: "مهم", info: "معلومة" },
    chat: {
      online: "متصل",
      offline: "غير متصل",
      conversations: "المحادثات",
      newChat: "محادثة جديدة",
      noConversations: "لا توجد محادثات بعد",
      listFailed: "تعذّر تحميل المحادثات",
      loadFailed: "تعذّر فتح المحادثة",
      untitled: "محادثة بلا عنوان",
      delete: "حذف",
      confirmDelete: "هل تريد حذف هذه المحادثة نهائيًا؟ لا يمكن التراجع عن هذا الإجراء.",
      deleteFailed: "تعذّر حذف المحادثة",
      copy: "نسخ",
      copied: "تم النسخ",
      stop: "إيقاف",
      welcome: "مرحبًا، أنا مساعد تمهيد. اسألني عن الطلاب والحضور والدروس والتقارير، وسأبحث لك في البيانات التي يحق لك رؤيتها.",
      suggestionsLabel: "اقتراحات",
      searching: "أبحث في",
      open: "فتح",
      thinking: "يكتب الرد…",
      tools: {
        attendance_summary: "الحضور",
        get_student: "ملف الطالب",
        list_lessons: "الدروس",
        my_reports: "التقارير",
        navigate: "الشاشات",
        notices: "لوحة الإعلانات",
        pending_items: "ما ينتظر الموافقة",
        search_students: "الطلاب",
        vehicle_alerts: "تنبيهات المركبات",
        whoami: "بيانات حسابك",
        other: "البيانات",
      },
      screens: {
        dashboard: "لوحة التحكم", students: "الطلاب", student: "ملف الطالب", lessons: "الدروس", lesson: "الدرس",
        attendance: "الحضور", reports: "التقارير", report: "التقرير", vehicles: "المركبات", vehicle: "المركبة",
        files: "الملفات", notices: "لوحة الإعلانات", users: "المستخدمون", user: "المستخدم", audit: "سجل التغييرات", profile: "الملف الشخصي",
      },
      suggest: {
        pending: "ما الذي ينتظر موافقتي؟",
        vehicles: "هل توجد تنبيهات للمركبات؟",
        absentAll: "من غاب أكثر من مرة هذا الأسبوع؟",
        absentMine: "من غاب من طلابي هذا الأسبوع؟",
        today: "ما دروس اليوم؟",
        myReports: "ما آخر تقاريري؟",
        help: "بماذا يمكنك مساعدتي؟",
      },
      errors: {
        INVALID_MESSAGE: "الرسالة فارغة أو طويلة جدًا.",
        NOT_FOUND: "هذه المحادثة لم تعد موجودة. ابدأ محادثة جديدة.",
        RATE_LIMITED: "وصلت إلى حدّ الرسائل للمساعد في هذه الساعة، حاول لاحقًا.",
        NOT_CONFIGURED: "المساعد غير مفعّل على الخادم بعد.",
        AI_UNAVAILABLE: "خدمة المساعد غير متاحة حاليًا.",
        AI_BUSY: "المساعد مشغول الآن، حاول بعد قليل.",
        AI_ERROR: "حدث خطأ في خدمة المساعد، حاول مرة أخرى.",
        SERVER_ERROR: "حدث خطأ غير متوقع، حاول مرة أخرى.",
        NETWORK: "انقطع الاتصال قبل اكتمال الرد. تحقق من الإنترنت وحاول مرة أخرى.",
        FORBIDDEN: "لا تملك صلاحية استخدام المساعد.",
        SESSION: "انتهت الجلسة. يُرجى تسجيل الدخول مرة أخرى.",
        BUSY: "المساعد ما زال يجيب في هذه المحادثة، انتظر حتى ينتهي ثم أرسل رسالتك.",
        CONVERSATION_FULL: "هذه المحادثة أصبحت طويلة جدًا. ابدأ محادثة جديدة للمتابعة.",
      },
      action: {
        heading: "إجراء مقترح بانتظار موافقتك",
        approve: "موافقة",
        cancel: "إلغاء",
        approving: "جارٍ التنفيذ…",
        waiting: "ستُفعَّل الأزرار بعد انتهاء الرد.",
        expiresAt: "ينتهي في",
        done: "تم التنفيذ.",
        cancelled: "تم الإلغاء. لم يتغير شيء.",
        refused: "لم يُنفَّذ الإجراء.",
        expired: "انتهت صلاحية الإجراء (15 دقيقة). اطلب من المساعد اقتراحه من جديد.",
        handled: "تم التعامل مع هذا الإجراء من قبل. راجع المحادثة لمعرفة النتيجة.",
        confirmNotice: "سيُنشر هذا الإعلان للمستخدمين. هل تريد المتابعة؟",
        confirmApproveUser: "سيتم تفعيل هذا الحساب بالدور المذكور. هل تريد المتابعة؟",
        types: {
          attendance: "تسجيل حضور",
          add_student_to_lesson: "إضافة طالب إلى درس",
          report: "تقرير يومي",
          notice: "إعلان",
          approve_user: "قبول مستخدم",
        },
        labels: {
          lesson: "الدرس", date: "التاريخ", student: "الطالب", tz: "رقم الهوية", user: "المستخدم", role: "الدور",
          title: "العنوان", text: "النص", body: "نص الإعلان", severity: "الأهمية", rows: "الصفوف",
          before: "القيمة السابقة", name: "الطالب", status: "الحالة", notes: "ملاحظة",
        },
        reasons: {
          FORBIDDEN: "لم تعد لديك صلاحية لهذا الإجراء. لم يتغير شيء.",
          NOT_POSSIBLE: "لم يعد هذا الإجراء ممكنًا (تغيّر وضع البيانات). لم يتغير شيء.",
          FAILED: "فشل التنفيذ على الخادم. تحقق من البيانات ثم اطلب الإجراء من جديد.",
          NOT_FOUND: "هذا الإجراء غير موجود.",
          ALREADY_USED: "تم استخدام هذا الإجراء من قبل.",
          BUSY: "المساعد ما زال يجيب في هذه المحادثة. حاول مرة أخرى بعد قليل.",
          NETWORK: "انقطع الاتصال. تحقق من الإنترنت وحاول مرة أخرى.",
          SESSION: "انتهت الجلسة. يُرجى تسجيل الدخول مرة أخرى.",
          SERVER_ERROR: "حدث خطأ غير متوقع، حاول مرة أخرى.",
        },
      },
    },
  },
};
